export const navigationRoutes = {
    navigateToLogin                                                 : '/login',
    navigateToAuthScof                                              : '/auth-scof',
    navigateToCheckoutScof                                          : '/checkout-scof',
    navigateToReturnToApp                                           : '/return-to-app',
    navigateToNotFound                                              : '/not-found',
}
